import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
} from '@angular/router';
import { map } from 'rxjs';
import { hasAnyPermission } from './permissions';
import { IdentityService } from '../services/identity';

export function requireAnyPermission(requiredPermissions: readonly string[]): CanActivateFn {
  if (requiredPermissions.length === 0) {
    return () => true;
  }

  return () => {
    const identity = inject(IdentityService);
    const router = inject(Router);

    return identity
      .waitForBermwoodInternalToken()
      .pipe(
        map(() =>
          hasAnyPermission(identity.permissions(), requiredPermissions)
            ? true
            : router.createUrlTree(['/unauthorized']),
        ),
      );
  };
}
